import Swiper, { Pagination, EffectFade, Navigation, Autoplay } from 'swiper';
import MmenuLight from  'mmenu-light/src/mmenu-light';
import MicroModal from 'micromodal';

//https://micromodal.vercel.app/

Swiper.use([Pagination, EffectFade, Navigation, Autoplay ]);

document.addEventListener("DOMContentLoaded", () => {


    MicroModal.init();

    const projectWrapper = document.getElementById('app');
    let m = document.querySelector( "#mobile-menu" );

    if (m){ // validation needed as there are some pages that dont contain top nav menu (custom landing pages)

        // Mobile menu init // Sync search and menu open
        const menu = new MmenuLight(m,"(max-width: 1024px)" );
        const navigator = menu.navigation();
        const drawer = menu.offcanvas();

        // Open Menu
        const navTrigger = document.querySelector('.js-open-nav');

        if (navTrigger) {
            // Toggle Menu
            bindEvent(navTrigger, "click", function() {
                this.classList.toggle('is-active');
                projectWrapper.classList.toggle('js-is-open');

                if (this.classList.contains('is-active')) {
                    drawer.open();
                } else {
                    drawer.close();
                }

            });
        }
    }

    // Swiper

    const swiper = new Swiper('.swiper-home', {
        // loop: true,
        effect: 'fade',
        loop: true,
        speed: 500,
        slidesPerView: 1,

        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    // Swiper gallery

    let swiperGalleryWrap = document.querySelector('.swiper-gallery')

    if(swiperGalleryWrap) {
        var swiperGallery = new Swiper('.swiper-gallery', {

            grabCursor: 'true',
            slidesPerView: 1,
            spaceBetween: 30,
    
            breakpoints: {
                768: {
                    spaceBetween: 64,
                },
            },
    
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    const overlayTriggersGallery = document.querySelectorAll('.js-open-gallery'),
        overlayGallery = document.getElementById('overlay-gallery'),
        closeGallery = document.getElementById('js-close-modal-gallery'),
        modal = document.querySelector('.js-modal'),
        overlays = document.querySelectorAll('.js-overlays');

        if(overlayTriggersGallery.length){ 
            for (var i = 0; i < overlayTriggersGallery.length; i++) {
                overlayTriggersGallery[i].addEventListener('click',  function(e) {
                    e.stopPropagation()
                    overlayGallery.classList.add('show');

                    const slideNumber = this.getAttribute('data-position');
                    swiperGallery.slideTo(slideNumber);
                });
            }

            if(closeGallery){ 
                closeGallery.addEventListener('click', function(){
                    overlayGallery.classList.remove("show");
                    
                });
            }

            overlayGallery.querySelector('[gallery-part]').addEventListener('click', function(e) {
                console.log(e.target.parentNode.id)
                if (e.target.closest('#js-close-modal-gallery')) return;
                e.stopPropagation()
            })

            //Closes the modal when the document is clicked
            for (var i = 0; i < overlays.length; i++) {
                overlays[i].addEventListener('click',  function() {
                    this.classList.remove('show');
                });
            }

            //Prevents the click event from reaching the document
            projectWrapper.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            if(modal){
                modal.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }

        }

    const overlayTriggersSearch = document.querySelectorAll('.js-open-search'),
        overlaySearch = document.getElementById('overlay-search');

        if(overlayTriggersSearch.length){ 
            for (var i = 0; i < overlayTriggersSearch.length; i++) {
                overlayTriggersSearch[i].addEventListener('click',  function(e) {
                    e.stopPropagation()
                    overlaySearch.classList.add('show');

                    projectWrapper.classList.add('js-is-open');
                });
            }

            if(closeGallery){ 
                closeGallery.addEventListener('click', function(){
                    overlaySearch.classList.remove("show");
                    projectWrapper.classList.remove('js-is-open');
                });
            }

            //Closes the modal when the document is clicked
            for (var i = 0; i < overlays.length; i++) {
                overlays[i].addEventListener('click',  function() {
                    this.classList.remove('show');
                    projectWrapper.classList.remove('js-is-open');
                });
            }

            //Prevents the click event from reaching the document
            projectWrapper.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            if(modal){
                modal.addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }

        }

    // Accordions
    const accordionItems = document.querySelectorAll('[data-accordion-item]');
    const expandAllButtons = document.querySelectorAll('[expand-all]')

    expandAllButtons.forEach(function(button) {

        bindEvent(button, 'click', function() {
            const links = button.previousElementSibling.querySelectorAll('[data-accordion-link]')
            if (Array.from(links).every(link => link.classList.contains('is-active'))) {
                return links.forEach(link => {
                    link.classList.remove('is-active')
                    link.nextElementSibling.classList.remove('is-active')
                    link.setAttribute('aria-expanded', 'false');
                    button.innerText = 'Expand all'
                })
            }
            links.forEach(link => {
                link.classList.add('is-active')
                link.nextElementSibling.classList.add('is-active')
                link.setAttribute('aria-expanded', 'true');
                button.innerText = 'Hide all'
            })
        })
    })

    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionLink = accordion.firstElementChild;
            bindEvent(accordionLink, 'click', toggleAccordion);
        });
    }

    function toggleAccordion(e) {
        const link = this.closest('[data-accordion-link]');
        const parent = link.closest('[data-accordion]');
        const content = parent.querySelectorAll('[data-accordion-content]');

        content.forEach(function(content) {
            if (content.previousElementSibling === link) {
                content.classList.toggle('is-active');
                link.classList.toggle('is-active');
                link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
                const list = content.closest('[data-accordion]')
                const links = list.querySelectorAll('[data-accordion-link]')
                if (Array.from(links).every(link => link.classList.contains('is-active'))) {
                    list.nextElementSibling.innerText = 'Hide all'
                } else {
                    list.nextElementSibling.innerText = 'Expand all'
                }
            }
            else {
                if(!("accordionAllowMultiple" in content.parentNode.parentNode.dataset)) {
                    content.classList.remove('is-active');
                    content.previousElementSibling.classList.remove('is-active');
                    content.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    // wrapping form
    const el = document.querySelectorAll('.form-element__form')

    el.forEach(item => {  
        const wrapper = document.createElement("section");
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);
        item.classList.add('container', 'px-6');

        item.parentNode.classList.add('section-form', 'section-p');
    });

    // wrapping tables in divs
    const elTable = document.querySelectorAll('.wysiwyg-block table')

    elTable.forEach(item => {  
        const wrapper = document.createElement("div");
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);

        item.parentNode.classList.add('table-wrapper');
    });


    //Click function
    function bindEvent(el, eventName, eventHandler) {
	    if (el.addEventListener){
	        el.addEventListener(eventName, eventHandler, false);
	    } else if (el.attachEvent){
	        el.attachEvent('on'+eventName, eventHandler);
	    }
	}

});